import { render, staticRenderFns } from "./goodEdit.vue?vue&type=template&id=471bb956&scoped=true&"
import script from "./goodEdit.vue?vue&type=script&lang=js&"
export * from "./goodEdit.vue?vue&type=script&lang=js&"
import style0 from "./goodEdit.vue?vue&type=style&index=0&id=471bb956&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "471bb956",
  null
  
)

export default component.exports